export default __webpack_public_path__ + "static/case_2-c6f012c3652e2208162fbd7f274d9393.png";